import styled from 'styled-components'

export const HeaderRow = styled.div`
  display: flex;
  align-items: flex-start;
  width: 100%;
  box-sizing: border-box;
  /* Keep the breadcrumb and site selector dropdown above banner backgrounds, but below GlobalNav (z-index: 5) */
  position: relative;
  z-index: 4;

  > nav {
    flex: 1 1 auto;
    min-width: 0;
  }

  /* Pin the site selector to the right edge of the row so it lines up with the page content */
  > nav + * {
    flex: 0 0 auto;
    width: auto;
    max-width: none;
    margin: 0;
    padding-top: 1.25rem;
    padding-left: 0;
    padding-right: 0;
  }
`
